import React from 'react';
import { FlameIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
export function OfferBar() {
  const {
    minutes,
    seconds
  } = useCountdown(900);
  return <div className="fixed top-0 left-0 w-full bg-gradient-to-r from-brand-black-light to-[#0B0F1A] text-white text-center py-2.5 px-4 font-bold text-sm z-50 shadow-md border-b border-primary/30 flex items-center justify-center gap-1.5" data-id="element-307">
      <FlameIcon className="w-4 h-4 text-primary" aria-hidden="true" data-id="element-308" />
      <span data-id="element-309">SOLO POR HOY +5 BONOS GRATIS </span>
      <span className="text-primary font-extrabold animate-pulse-accent ml-2" data-id="element-310">
        {minutes}:{seconds}
      </span>
    </div>;
}